/** Раскладка кнопок по рядам, как её соберёт движок: columns в ряд, «с нового ряда» переносит. */
export function layoutRows<T extends { newRow?: boolean }>(buttons: T[], columns: number): T[][] {
	const rows: T[][] = []
	for (const button of buttons) {
		const lastRow = rows[rows.length - 1]
		if (lastRow && !button.newRow && lastRow.length < columns) lastRow.push(button)
		else rows.push([button])
	}
	return rows
}
